<template>
  <div class="wrapper home">
    <div class="block contentwidth">
      <el-carousel
        trigger="click"
        :height="windowwidth <= 500 ? '600px' : '480px'"
      >
        <el-carousel-item v-for="item in newsList2" :key="item">
          <div class="bannerl">
            <img
              :src="$store.store.state.windonsrc + item.imgBase64"
              style="width: 100%; height: 100%; cursor: pointer"
              @click="goInfo(item.id, '/front/news/info/', 1)"
            />
            <div class="bannertitle">{{ item.title }}</div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="wrapper contentBg">
      <div class="contentwidth">
        <div class="wrapper white home_content flex home_notice">
          <div class="home_notice_in">
            <router-link to="/notice" class="home_tltie1 flex">
              <div
                class="home_tltie1_name"
                style="margin-bottom: -6px"
                @click="lookMore('/notice', '')"
              >
                通知公告
              </div>
              <el-link
                type="info"
                :underline="false"
                @click="lookMore('/notice', '')"
                style="padding-bottom: -15px; margin-top: 10px"
                class="more"
                >更多》</el-link
              >
            </router-link>
            <!-- <div class="home_notice_img">
                
                  <img :src="$store.store.state.windonsrc + titletop.imgBase64"
                    style="width: 100%; height: 100%" v-if="titletop.imgBase64" />
                  <img :src="$store.store.state.windonsrc + coverList.imgBase64" style="width: 100%; height: 100%"
                    v-else />
                  <div class="tiptitles"   @click="goInfo(titletop.id, '/front/news/info/')">
                    <p ><a :title="titletop.title">{{titletop.title}}</a></p>
                  </div>
                </div> -->
            <div
              class="wrapper home_notice_info home_notice_no"
              style="margin-top: -60px"
            >
              <el-tabs v-model="activeNameNotice" @tab-click="noticeClick">
                <el-tab-pane
                  v-for="(newsItem, index) in newsList"
                  :name="index"
                  :key="index"
                  :id="newsItem.id"
                >
                  <div class="home_notice_list_">
                    <div
                      class="home_notice_list flex"
                      v-for="(
                        contentItem, contentIndex
                      ) in newsItem.newsContent"
                      :key="contentIndex"
                      :id="contentItem.id"
                      @click="goInfo(contentItem.id, '/front/news/info/', 1)"
                    >
                      <div>
                        <a :title="contentItem.title">{{
                          contentItem.title
                        }}</a>
                      </div>
                      <div class="boxes">
                        {{ contentItem.createTime.slice(0, 10) }}
                      </div>
                    </div>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>
          <div class="home_notice_in home_content_in2">
            <router-link to="/enchiridion" class="home_tltie1 flex">
              <div
                class="home_tltie1_name"
                style="margin-bottom: -6px"
                @click="lookMore('/enchiridion', '')"
              >
                办事指南
              </div>
              <el-link
                type="info"
                :underline="false"
                @click="lookMore('/enchiridion', '')"
                style="margin-bottom: -15px"
                class="more"
                >更多》</el-link
              >
            </router-link>
            <!-- <div class="home_notice_img">
                  <img :src="$store.store.state.windonsrc + coverList[1].imgBase64" style="width: 100%; height: 100%" />
                </div> -->
            <div
              class="wrapper home_notice_info home_notice_no"
              style="margin-top: -60px"
            >
              <el-tabs>
                <el-tab-pane label="" name="0">
                  <div class="home_notice_list_">
                    <!-- <div
                          class="home_notice_list flex"
                          v-for="(guideItem, index) in guideList"
                          :key="index"
                          :id="guideItem.id"
                          @click="
                            goInfo(guideItem.id, '/front/handleGuide/info/')
                          "
                        >
                          <div>
                            <a :title="guideItem.title">{{
                              guideItem.title
                            }}</a>
                          </div>
                          <div>{{ guideItem.createTime.slice(0, 10) }}</div>
                        </div> -->
                    <ul class="home_notice_list_ul">
                      <li
                        v-for="(item, index) in wmenulist2"
                        :key="index"
                        @click="pathban(item, index, 1)"
                      >
                        <div class="dice_bank">
                          <img
                            src="../../static/images/common/jt.png"
                            class="jt1"
                          />
                          <img
                            src="../../static/images/common/jt2.png"
                            class="jt2"
                          />
                        </div>
                        <div class="dice_banks">{{ item.menuName }}</div>
                      </li>
                    </ul>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>

          <!-- <div class="home_notice_in">
            <div class="home_notice_img">
              <img
                :src="$store.store.state.windonsrc + coverList[2].imgBase64"
                style="width: 100%; height: 100%"
              />
            </div>
            <div class="wrapper home_notice_info">
              <router-link to="/policy" class="home_title2 flex">
                <div class="home_title2_border"></div>
                <span>政策法规</span>
              </router-link>
              <el-tabs v-model="activeNamePolicy" @tab-click="policyClick">
                <el-tab-pane
                  v-for="(policyItem, index) in policyList"
                  :label="policyItem.menuName"
                  :name="index"
                  :key="index"
                  :id="policyItem.id"
                >
                  <div class="home_notice_list_">
                    <div
                      class="home_notice_list"
                      v-for="(
                        contentItem, contentIndex
                      ) in policyItem.newsContent"
                      :key="contentIndex"
                      :id="contentItem.id"
                      @click="
                        goInfo(contentItem.id, '/front/policeRegulation/info/')
                      "
                    >
                      {{ contentItem.title }}
                    </div>
                  </div>
                  <div class="flex">
                    <el-link
                      type="info"
                      :underline="false"
                      @click="lookMore('/policy', activeNamePolicy)"
                      >更多》</el-link
                    >
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
          </div> -->
        </div>
        <div class="white home_content">
          <!-- <el-row> -->
          <!-- <el-col :xs="24" :sm="24" :md="24" :lg="24"> -->
          <div class="home_tltie1 flex">
            <!-- <div class="home_tltie1_name" @click="lookMore('/center', '')">
                  医学伦理委员会
                  <span style="font-size: 16px;
                  font-family: Arial;
                  font-weight: 400;
                  color: #1A1A1A;">// medical ethic committee</span>
                </div> -->
            <div
              class="content_list_title"
              style="border: none"
              @click="lookMoreHerf('2', '/center')"
            >
              <p>
                医学伦理委员会
                <span
                  style="
                    font-size: 16px;
                    font-family: Arial;
                    font-weight: 400;
                    color: #1a1a1a;
                    margin-left: 10px;
                  "
                  >// medical ethic committee</span
                >
              </p>
              <p class="content_list_title_border" style="width: 101px"></p>
            </div>
            <!-- <el-link
                  :underline="false"
                  @click="lookMoreHerf('2', '/center')"
                  >更多》</el-link
                > -->
          </div>
          <!-- </el-col> -->

          <div class="home_synopsis">
            <!-- <el-col :xs="24" :sm="24" :md="24" :lg="10"> -->
            <div>
              <div class="home_synopsis_info">
                <div v-html="clinicalCenter.content"></div>
              </div>
              <div class="flex">
                <div
                  class="home_synopsis_more"
                  @click="lookMoreHerf('2', '/center')"
                >
                  <i class="el-icon-circle-plus"></i>
                  <span>查看更多</span>
                </div>
              </div>
            </div>
            <!-- </el-col> -->
            <!-- <el-col :xs="24" :sm="24" :md="24" :lg="14"> -->
            <div class="flex">
              <!-- <img
                :src="$store.store.state.windonsrc + clinicalCenter.imgBase64"
                style="width: 440px; height: auto"
                class="smimagae"
              /> -->
              <div class="znnew">
                <p
                  class="home_synopsis_more"
                  @click="pathban(wmenulist[0], 0, 2)"
                >
                  办事指南
                </p>
                <ul>
                  <li
                    v-for="(item, index) in wmenulist"
                    :key="index"
                    @click="pathban(item, index, 2)"
                  >
                    <div class="dice_bank">
                      <img
                        src="../../static/images/common/jt.png"
                        class="jt1"
                      />
                      <img
                        src="../../static/images/common/jt2.png"
                        class="jt2"
                      />
                    </div>
                    <div class="dice_banks">{{ item.menuName }}</div>
                  </li>
                </ul>
              </div>
            </div>
            <!-- </el-col> -->
          </div>
          <!-- </el-row> -->
        </div>
        <!-- <div class="white home_content">
          <el-row>
            <el-col :xs="24" :sm="24" :md="24" :lg="24">
              <div class="home_tltie1 flex">
                <div class="home_tltie1_name" @click="lookMoreHerf(2, '/')">
                  医学伦理委员会
                  <span>// MEDICAL ETHIC COMMITTEE</span>
                </div>
                <el-link :underline="false" @click="lookMoreHerf(2, '/notice')">更多》</el-link>
              </div>
            </el-col>
            <div class="home_ethic">
              <el-col :xs="24" :sm="24" :md="24" :lg="12" v-for="(ethicNewsItem, index) in ethicNewsList" :key="index"
              @click="goInfo(ethicNewsItem.id, '/front/news/info/')">
                <div class="home_ethic_in" >
                  <div class="home_ethic_img">
                    <img :src="$store.store.state.windonsrc + ethicNewsItem.imgBase64"
                      style="width: 100%; height: 100%" />
                  </div>
                  <div class="home_ethic_info">
                    <div class="home_ethic_time">
                      {{ ethicNewsItem.updateTime.slice(0, 10) }}
                    </div>
                    <div class="home_ethic_info_text">
                      {{ ethicNewsItem.title }}
                    </div>
                    <div class="el-icon-caret-left home_ethic_horn"></div>
                  </div>
                </div>
              </el-col>
            </div>
          </el-row>
        </div> -->
        <div class="white home_content">
          <!-- <el-row>
            <el-col :xs="24" :sm="24" :md="24" :lg="24"> -->
          <div class="home_tltie1 flex">
            <!-- <div class="home_tltie1_name" @click="lookMoreHerf(3, '/')">
                  技术转移机构
                  <span>// TECHNOLOGY TRANSFER OFFICE</span>
                </div> -->
            <div
              class="content_list_title"
              style="border: none"
              @click="lookMoreHerf(3, '/patentRecommendation')"
            >
              <p>
                技术转移机构
                <span
                  style="
                    font-size: 16px;
                    font-family: Arial;
                    font-weight: 400;
                    color: #1a1a1a;
                    margin-left: 10px;
                  "
                  >// TECHNOLOGY TRANSFER OFFICE</span
                >
              </p>
              <p class="content_list_title_border" style="width: 101px"></p>
            </div>
            <el-link
              :underline="false"
              @click="lookMoreHerf(3, '/patentRecommendation')"
              >更多》</el-link
            >
          </div>
          <!-- </el-col> -->
          <div class="home_technology">
            <!-- <el-col :xs="24" :sm="24" :md="24" :lg="10"> -->
            <div class="home_technology_img">
              <img :src="require('../../static/images/home/technology.png')" />
            </div>
            <!-- </el-col> -->
            <!-- <el-col :xs="24" :sm="24" :md="24" :lg="14"> -->
            <div class="home_technology_info">
              <div
                class="home_title2 flex"
                @click="lookMoreHerf(3, '/patentRecommendation')"
                style="margin-top: -6px"
              >
                <div class="home_title2_border"></div>
                <span>专利推介</span>
              </div>
              <ul class="flex patentRecommendationItems">
                <li
                  v-for="(
                    patentRecommendationItem, index
                  ) in patentRecommendationList"
                  :key="patentRecommendationItem.id"
                  :class="
                    index == patentRecommendationItemindex
                      ? 'patentRecommendationItemshover'
                      : ''
                  "
                  @mouseenter="
                    checkfunindex(index, patentRecommendationItem.id)
                  "
                >
                  {{ patentRecommendationItem.menuName }}
                </li>
              </ul>
              <div
                class="flex home_technology_in"
                v-for="(contentItem, contentIndex) in patentRecommendationList[
                  patentRecommendationItemindex
                ].newsContent"
                :key="contentIndex"
                :id="contentItem.id"
                @click="goInfo(contentItem.id, '/front/Patenpromotion/info/', 5)"
              >
                <div class="home_notice_list_left">
                  {{ contentItem.title }}
                </div>
                <div class="home_notice_list_right">
                  <i class="el-icon-time"></i>
                  {{ contentItem.createTime.slice(0, 10) }}
                </div>
              </div>
              <!-- <el-tabs
                    v-model="activeNamePatentRecommendation"
                    @tab-click="patentRecommendationClick"
                  >
                    <el-tab-pane
                      v-for="(
                        patentRecommendationItem, index
                      ) in patentRecommendationList"
                      :label="patentRecommendationItem.menuName"
                      :name="index"
                      :key="index"
                      :id="patentRecommendationItem.id"
                    >
                    
                    </el-tab-pane>
                  </el-tabs> -->
            </div>
            <!-- </el-col> -->
          </div>
          <!-- </el-row> -->
        </div>
        <div class="white home_content">
          <div class="home_tltie1 flex" style="margin-bottom: 25px">
            <!-- <div class="home_tltie1_name" @click="lookMore('/GCP', '')">
              GCP专业科室
              <span>// GCP SPECIALIZED DEPARTMENTS</span>
            </div> -->
            <div
              class="content_list_title"
              style="border: none"
              @click="lookMore('/GCP', '')"
            >
              <p>
                GCP专业科室
                <span
                  style="
                    font-size: 16px;
                    font-family: Arial;
                    font-weight: 400;
                    color: #1a1a1a;
                    margin-left: 10px;
                  "
                  >// GCP SPECIALIZED DEPARTMENTS</span
                >
              </p>
              <p class="content_list_title_border" style="width: 101px"></p>
            </div>
            <el-link :underline="false" @click="lookMore('/GCP', '')"
              >更多》</el-link
            >
          </div>
          <div
            class="home_GCP"
            @mouseover="GCPMouseOver"
            @mouseleave="GCPMouseLeave"
          >
            <div
              class="carousel_btn carousel_btn_left"
              @click="GCPBtnRight"
            ></div>
            <div
              class="carousel_btn carousel_btn_right"
              @click="GCPBtnLfet"
            ></div>
            <div class="home_GCP_content">
              <div class="home_GCP_content_in">
                <div
                  class="flex home_GCP_main"
                  :style="{
                    width: GCPList.length * 204 + 'px',
                    transform: GCPLeft,
                  }"
                >
                  <a
                    class="home_GCP_in"
                    v-for="(GCPItem, index) in GCPList"
                    :key="index"
                    :id="GCPItem.id"
                    @click="pathkes(index)"
                    target="_blank"
                  >
                    <div class="flex home_GCP_icon">
                      <img
                        :src="$store.store.state.windonsrc + GCPItem.imgBase64"
                      />
                    </div>
                    <div class="home_GCP_border"></div>
                    <div class="home_GCP_department">
                      {{ GCPItem.department }}
                    </div>
                    <!-- <div class="home_GCP_name">
                      {{ GCPItem.personEntitys[0].name }}
                      {{ GCPItem.personEntitys[0].jobTitle }}
                    </div> -->
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="home_system">
          <div class="home_system_in home_system_in1">
            <div class="systemIcon1 home_system_icon"></div>
            <div class="home_system_info">
              <p>临床试验中心管理系统(外网)</p>
              <p class="home_system_english">
                Clinical Trial Center Management System (Extranet)
              </p>
            </div>
          </div>
          <div class="home_system_in home_system_in2">
            <div class="systemIcon1 home_system_icon"></div>
            <div class="home_system_info">
              <p>临床试验中心管理系统</p>
              <p class="home_system_english">
                Clinical Trial Center Management System
              </p>
            </div>
          </div>
          <div class="home_system_in home_system_in3" @click="goDownload">
            <div class="systemIcon3 home_system_icon"></div>
            <div class="home_system_info">
              <p>下载中心</p>
              <p class="home_system_english">Download Center</p>
            </div>
          </div>
        </div> -->

        <div class="white home_link">
          <div class="flex home_link_info home_link_related">
            <div class="flex home_link_related_left">
              <div
                class="home_link_related_border"
                :style="{ borderBottom: relatedBorderBottom }"
              ></div>
              <div class="home_link_left_text">
                <p class="home_link_title">系统链接</p>
                <p>Related Links</p>
              </div>
            </div>
            <div class="flex home_link_related_right">
              <a
                class="flex home_link_related_in"
                v-for="(relatedLinksItem, index) in relatedLinksList"
                :key="index"
                :href="relatedLinksItem.linkUrl"
                target="_blank"
              >
                <div class="home_link_related_icon">
                  <img
                    :src="
                      $store.store.state.windonsrc + relatedLinksItem.imgBase64
                    "
                    style="width: 100%; height: 100%"
                  />
                </div>
                <el-link class="home_link_related_name" :underline="false">{{
                  relatedLinksItem.title
                }}</el-link>
              </a>
            </div>
          </div>
        </div>
        <div class="white home_link">
          <div class="flex home_link_info home_link_links">
            <div class="flex home_link_links_left">
              <div
                class="home_link_links_border"
                :style="{ borderBottom: linksBorderBottom }"
              ></div>
              <div class="home_link_left_text">
                <p class="home_link_title">友情链接</p>
                <p>Friendship Links</p>
              </div>
            </div>
            <div
              class="home_link_links_right"
              @mouseover="linksMouseOver"
              @mouseleave="linksMouseLeave"
            >
              <div
                class="carousel_btn carousel_btn_left"
                @click="linksBtnRight"
              ></div>
              <div
                class="carousel_btn carousel_btn_right"
                @click="linksBtnLfet"
              ></div>
              <div class="links_carousel">
                <div
                  class="flex links_carousel_main"
                  :style="{
                    width: friendshipLinksList.length * 255 + 'px',
                    transform: linksLeft,
                  }"
                >
                  <a
                    class="flex home_link_links_in"
                    v-for="(friendshipLinksItem, index) in friendshipLinksList"
                    :key="index"
                    :href="friendshipLinksItem.linkUrl"
                    target="_blank"
                  >
                    <i class="el-icon-caret-right home_link_links_icon"></i>
                    <el-link class="home_link_links_name" :underline="false">{{
                      friendshipLinksItem.title
                    }}</el-link>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getmenu,
  bannerQuery,
  policyQuery,
  GCPQuery,
  allNewsQuery,
  allGuideQuery,
  linkQuery,
  ethicNewsQuery,
  patentRecommendation,
} from "@/request/api";
export default {
  name: "HelloWorld",
  data() {
    return {
      patentRecommendationItemindex: 0,
      activeNameNotice: 0,
      activeNamePolicy: 0,
      relatedBorderBottom: "",
      linksBorderBottom: "",
      bannerList: [], //banner图
      coverList: [], //封面图
      newsMenu: [], //通知公告tab
      newsList: [], //通知公告列表
      guideList: [], //办事指南列表
      policyList: [], //政策法规列表
      clinicalCenter: "", //中心介绍-临床试验中心
      GCPList: "", //GCP专业科室
      newsId: "26", //通知公告传的id 默认重要公告
      relatedLinksList: [], //相关链接
      friendshipLinksList: [], //友情链接
      patentList: [], //专利推荐
      ethicNewsList: [], //伦理委员会-重要公告
      patentRecommendationList: [], //专利推介
      GCPNum: 0,
      GCPTimer: "",
      GCPLeft: "",
      linksNum: 0,
      linksTimer: "",
      linksLeft: "",
      wmenulist: [],
      titletop: [],
      newsList2: [],
      wmenulist2: [],
      windowwidth: window.screen.width,
    };
  },
  created() {
    this.bannerQuery_Fun(1, 54); //banner图

    this.bannerQuery_Fun(0, 55); //封面图
    this.bannerQuery_Fun(2, 102); //临床试验中心介绍

    this.getmenu_Fun(15); //通知公告
    this.allGuideQuery_Fun(19); //办事指南
    this.getmenu_Fun(31); //政策法规
    this.GCPQuery_Fun(20); //GCP专业科室
    this.linkQuery_Fun(393); //链接管理-系统链接
    this.linkQuery_Fun(41); //链接管理-友情链接
    this.ethicNewsQuery_Fun(); //伦理委员会-重要公告
    this.getmenu_Fun(97); //专利推介
    this.bannerQuery_Fun2(); //伦理委员会
    this.getmenu_Fun2(1);
    this.getmenu_Fun2(2);
    setTimeout(() => {
      this.relatedBorderBottom =
        document.getElementsByClassName("home_link_related")[0].offsetHeight +
        "px solid #81b9ff";
      this.linksBorderBottom =
        document.getElementsByClassName("home_link_links")[0].offsetHeight +
        "px solid #5A99E6";
    }, 500);
  },
  mounted() {
    setTimeout(() => {
      this.relatedBorderBottom =
        document.getElementsByClassName("home_link_related")[0].offsetHeight +
        "px solid #81b9ff";
      this.linksBorderBottom =
        document.getElementsByClassName("home_link_links")[0].offsetHeight +
        "px solid #5A99E6";
    }, 500);
  },
  methods: {
    checkfunindex(index, id) {
      this.patentRecommendationItemindex = index;
      this.patentRecommendation_Fun(index, id);
    },
    getmenu_Fun2(type) {
      let params = {
        belongSystemId: type,
        pageNumber: 1,
        pageSize: 20,
        parentMenuId: 19,
      };
      getmenu(params)
        .then((res) => {
          if (res.data.code == 200) {
            if (type == 2) {
              this.wmenulist = res.data.data.list;
            } else if (type == 1) {
              this.wmenulist2 = res.data.data.list;
            }
          }
        })
        .catch(() => {});
    },
    getmenu_Fun(parentMenuId) {
      let params = {};
      if (parentMenuId == 97) {
        params = {
          belongSystemId: 3,
          parentMenuId: parentMenuId,
          pageSize: 10,
          pageNumber: 1,
        };
      } else {
        params = {
          parentMenuId: parentMenuId,
          pageSize: 10,
          pageNumber: 1,
        };
      }
      getmenu(params)
        .then((res) => {
          if (res.data.code == 200) {
            if (parentMenuId == 15) {
              //通知公告
              this.newsList = res.data.data.list;
              this.newsId = 26;
              this.allNewsQuery_Fun(0, this.newsId);
              this.allNewsQuery_Fun2(0, this.newsId);
            } else if (parentMenuId == 31) {
              //政策法规
              this.policyList = res.data.data.list;
              this.policyQuery_Fun(0, res.data.data.list[0].id);
            } else if (parentMenuId == 97) {
              //专利推介
              this.patentRecommendationList = res.data.data.list;
              this.patentRecommendation_Fun(0, res.data.data.list[0].id);
            }
          }
        })
        .catch((err) => {});
    },
    bannerQuery_Fun(type, blongToMenu) {
      let params = {};
      if (type == 0 || type == 1) {
        params = {
          blongToMenu: blongToMenu,
          pageSize: 10,
          pageNumber: 1,
          type: type,
        };
      } else {
        params = {
          blongToMenu: blongToMenu,
          pageSize: 1,
          pageNumber: 1,
        };
      }
      bannerQuery(params)
        .then((res) => {
          if (res.data.code == 200) {
            if (type == 1) {
              this.bannerList = res.data.data.list;
            } else if (type == 0) {
              this.coverList = res.data.data.list;
            }
          }
        })
        .catch((err) => {});
    },
    bannerQuery_Fun2() {
      let params = {
        belongSystemId: "2",
        blongToMenu: 103,
        pageNumber: 1,
        pageSize: 1,
      };
      bannerQuery(params)
        .then((res) => {
          this.clinicalCenter = res.data.data.list[0];
        })
        .catch((err) => {});
    },

    allNewsQuery_Fun(index, parentMenuId) {
      let params = {
        belongSystemId: 1,
        parentMenuId: parentMenuId,
      };
      allNewsQuery(params)
        .then((res) => {
          if (res.data.code == 200) {
            this.newsList[index].newsContent = res.data.data.slice(0, 5);
            this.titletop = res.data.data[0];
            this.$set(this.newsList, index, this.newsList[index]);
          }
        })
        .catch((err) => {});
    },

    allNewsQuery_Fun2(index, parentMenuId) {
      let params = {
        belongSystemId: 1,
        parentMenuId: parentMenuId,
        hasImage: 1,
      };
      allNewsQuery(params)
        .then((res) => {
          if (res.data.code == 200) {
            this.newsList2 = res.data.data.slice(0, 4);
          }
        })
        .catch((err) => {});
    },

    allGuideQuery_Fun(parentMenuId) {
      let params = {
        parentMenuId: parentMenuId,
      };
      allGuideQuery(params)
        .then((res) => {
          if (res.data.code == 200) {
            this.guideList = res.data.data.slice(0, 5);
          }
        })
        .catch((err) => {});
    },
    policyQuery_Fun(index, blongToMenu) {
      let params = {
        blongToMenu: blongToMenu,
        pageSize: 5,
        pageNumber: 1,
      };
      policyQuery(params)
        .then((res) => {
          if (res.data.code == 200) {
            this.policyList[index].newsContent = res.data.data.list;
            this.$set(this.policyList, index, this.policyList[index]);
          }
        })
        .catch((err) => {});
    },
    GCPQuery_Fun(blongToMenu) {
      let params = {
        blongToMenu: blongToMenu,
        pageSize: 1000,
        pageNumber: 1,
      };
      GCPQuery(params)
        .then((res) => {
          if (res.data.code == 200) {
            this.GCPList = res.data.data.list;
          }
        })
        .catch((err) => {});
    },
    linkQuery_Fun(blongToMenu) {
      // 相关链接
      let params = {
        blongToMenu: blongToMenu,
        pageSize: 50,
        pageNumber: 1,
      };
      linkQuery(params)
        .then((res) => {
          if (res.data.code == 200) {
            if (blongToMenu == 393) {
              // 相关链接
              this.relatedLinksList = res.data.data.list;
            } else if (blongToMenu == 41) {
              //友情链接
              this.friendshipLinksList = res.data.data.list;
            }
          }
        })
        .catch((err) => {});
    },
    ethicNewsQuery_Fun() {
      ethicNewsQuery()
        .then((res) => {
          if (res.data.code == 200) {
            this.ethicNewsList = res.data.data.list;
          }
        })
        .catch((err) => {});
    },

    noticeClick(tab, event) {
      if (tab.index == 0) {
        this.newsId = 26;
      } else {
        this.newsId = 28;
      }
      this.allNewsQuery_Fun(tab.index, this.newsId);
    },
    policyClick(tab, event) {
      this.policyQuery_Fun(tab.index, this.policyList[tab.index].id);
    },
    lookMore(url, num) {
      if (num) {
        this.$router.push({ path: url, query: { num: num } });
      } else {
        this.$router.push({ path: url });
      }
    },
    goDownload() {
      this.$router.push({ path: "/download" });
    },
    goInfo(id, url, type) {
      this.$router.push({
        name: "checkMsg",
        query: {
          id: id,
          type: type,
          // api: JSON.stringify({
          //   check: url,
          // }),
        },
      });
    },
    patentRecommendation_Fun(index, blongToMenu) {
      let params = {
        belongSystemId: 3,
        blongToMenu: blongToMenu,
        pageSize: 4,
        pageNumber: 1,
      };
      patentRecommendation(params).then((res) => {
        if (res.data.code == 200) {
          this.patentRecommendationList[index].newsContent = res.data.data.list;
          this.$set(
            this.patentRecommendationList,
            index,
            this.patentRecommendationList[index]
          );
        }
      });
    },
    pathkes(index) {
      this.$router.push({
        path: "/GCP",
        query: {
          index: index,
        },
      });
    },
    patentRecommendationClick(tab, event) {
      this.patentRecommendation_Fun(
        tab.index,
        this.patentRecommendationList[tab.index].id
      );
    },
    lookMoreHerf(menutype, url) {
      window.sessionStorage.setItem("menutype", menutype);
      this.$router.push({
        path: url,
      });
      // setTimeout(() => {
      //   location.reload();
      // }, 150);
    },
    // 滚动按钮
    GCPBtnLfet() {
      if (this.GCPNum > this.GCPList.length - 6) {
        this.GCPNum = 0;
      } else {
        this.GCPNum++;
      }
      this.GCPLeft = `translateX( ` + -this.GCPNum * 204 + "px" + `)`;
    },
    GCPBtnRight() {
      if (this.GCPNum == 0) {
        this.GCPNum = this.GCPList.length - 6;
      } else {
        this.GCPNum--;
      }
      this.GCPLeft = `translateX( ` + -this.GCPNum * 204 + "px" + `)`;
    },
    // 移入
    GCPMouseOver() {
      clearInterval(this.GCPTimer);
    },
    // 移出
    GCPMouseLeave() {
      this.GCPTimer = setInterval(this.GCPBtnLfet, 2500);
    },
    // 滚动按钮
    linksBtnLfet() {
      if (this.linksNum > this.friendshipLinksList.length - 5) {
        this.linksNum = 0;
      } else {
        this.linksNum++;
      }
      this.linksLeft = `translateX( ` + -this.linksNum * 255 + "px" + `)`;
    },
    linksBtnRight() {
      if (this.linksNum == 0) {
        this.linksNum = this.friendshipLinksList.length - 4;
      } else {
        this.linksNum--;
      }
      this.linksLeft = `translateX( ` + -this.linksNum * 255 + "px" + `)`;
    },
    // 移入
    linksMouseOver() {
      clearInterval(this.linksTimer);
    },
    // 移出
    linksMouseLeave() {
      this.linksTimer = setInterval(this.linksBtnLfet, 2500);
    },
    pathban(item, index, type) {
      if (item.id == "1545341608116715521") {
        window.sessionStorage.setItem("menutype", 2);
        this.$router.push({
          path: "/enchiridion",
          query: {
            id: item.id,
            index: 4,
            menuName: item.menuName,
            menutype:type
          },
        });
      } else {
        window.sessionStorage.setItem("menutype", type);
        this.$router.push({
          path: "/enchiridion",
          query: {
            id: item.id,
            index: index,
            menuName: item.menuName,
            menutype:type
          },
        });
      }
    },
  },
  mounted() {
    this.GCPTimer = setInterval(this.GCPBtnLfet, 2500);
    this.linksTimer = setInterval(this.linksBtnLfet, 2500);
  },
  beforeDestroy() {
    clearInterval(this.GCPTimer);
    clearInterval(this.linksTimer);
  },
};
</script>

<style>
.home .el-tabs__header {
  /* height: 40px;
  padding-left: 120px;
  padding-top: 3px; */
}
.boxes {
  width: 100px;
}
.home .el-tabs__nav-wrap::after {
  display: none;
}

.home .el-tabs__item {
  padding: 0px !important;
  width: 90px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  font-size: 16px;
  margin-right: 5px;
}

.home .el-tabs__active-bar {
  display: none;
}

/* .home .home_notice_no .el-tabs__nav-scroll, .home .home_notice_no .is-top {
    display: none;
  } */

.home_technology .el-tabs__item.is-active {
  width: 90px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background: rgba(82, 142, 228, 0.1);
  font-weight: bold;

  border-radius: 7px;
  color: #2975d3;
}

.home_technology .el-tabs__item:hover {
  background: rgba(82, 142, 228, 0.1);
  font-weight: bold;
  border-radius: 7px;
  color: #2975d3;
}

.el-tabs__nav {
  /* padding-left:110px; */
}

@media screen and (max-width: 576px) {
  .el-tabs__nav {
    padding: 0px !important;
  }
}
</style>
<style scoped>
.home {
  background-color: #f0f6ff;
}

.contentBg {
  padding-top: 30px;
}

.home_system {
  height: 60px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
}

.home_system_in {
  width: 390px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #3974d6;
  padding: 0 20px;
  cursor: pointer;
}

.home_system_in1 {
  background: url(../../static/images/common/systemBg1.png) no-repeat;
}

.home_system_in2 {
  background: url(../../static/images/common/systemBg2.png) no-repeat;
}

.home_system_in3 {
  background: url(../../static/images/common/systemBg3.png) no-repeat;
}

.home_system_info p {
  font-size: 18px;
  text-align: right;
  color: #fff;
  line-height: 22px;
}

.home_system_info .home_system_english {
  font-size: 12px;
}

.home_content {
  box-shadow: 0px 2px 5px 0px rgba(126, 126, 126, 0.24);
  padding: 20px 50px 30px;
  margin-bottom: 30px;
}

.home_link {
  box-shadow: 0px 2px 5px 0px rgba(126, 126, 126, 0.24);
  margin-bottom: 30px;
}

.home_link:last-child {
  margin-bottom: 0;
}

.home_notice {
  justify-content: space-between;
}

.home_notice_in {
  /* width: 557px; */
  /* margin-right: 100px; */
}

/* .el-col .home_notice_in:last-child{
    margin-right: 0px;
  } */
.home_notice_img {
  width: 100%;
  height: 219px;
  margin-bottom: 20px;
  position: relative;
}

.tiptitles {
  position: absolute;
  bottom: 0px;
  left: 0px;
  width: 100%;
  height: 44px;
  background: rgba(13, 125, 252, 0.38);
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  line-height: 44px;
  padding-left: 15px;
  box-sizing: border-box;

  /* opacity: 0.38; */
}

.tiptitles p {
  width: 406px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.home_notice_info {
  position: relative;
}

.home_tltie1 {
  width: 100%;
  height: 55px;
  border-bottom: 3px solid #d6d6d6;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 35px;
  position: relative;
}

.home_tltie1_name {
  height: 55px;
  border-bottom: 3px solid #d40a2a;
  line-height: 55px;
  font-size: 20px;
  color: #1a1a1a;
  cursor: pointer;
  font-weight: 600;
  margin-bottom: -3px;
}

.home_tltie1_name span {
  font-size: 16px;
}

.home_title_top {
  height: 40px;
  font-size: 20px;
  color: #4d4d4d;
  line-height: 30px;
  padding: 5px 0;
  font-weight: bold;
  cursor: pointer;
  margin-bottom: 20px;
  border-bottom: solid 2px #eee;
}

.home_title2 {
  height: 40px;
  font-size: 20px;
  color: #4d4d4d;
  line-height: 30px;
  padding: 5px 0;
  font-weight: bold;
  cursor: pointer;
}

.home_title2_border {
  width: 6px;
  height: 30px;
  background-color: #d40a2a;
  margin-right: 14px;
}

.home_notice_info .home_title2 {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
}

.home_content_in2 {
  margin-left: 50px;
}

.home_notice_list_ {
  height: 175px;
  margin-bottom: 10px;
  padding-left: 5px;
}

.home_notice_list {
  width: 100%;
  height: 38px;
  border-bottom: 1px dashed #e0e0e0;

  line-height: 38px;
  font-size: 15px;
  color: #4d4d4d;
  text-align: justify;
  cursor: pointer;
}

.home_notice_list div:first-child {
  width: 580px;
  margin-right: 30px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.home_notice_list:hover {
  color: #1468b9;
}

.home_synopsis {
  display: flex;
  justify-content: space-between;
}

.home_synopsis_info {
  /* width: 450px; */
  /* height: 400px; */
  width: 940px;
  height: 330px;
  margin-bottom: 20px;
  text-align: justify;
  text-justify: inter-ideograph;
  overflow: hidden;
}

.home_synopsis_more {
  height: 28px;
  background-color: #1468b9;
  border-radius: 100px;
  display: flex;
  justify-content: space-between;
  padding: 0 10px;
  line-height: 28px;
  align-items: center;
  color: #fff;
  cursor: pointer;
}

.home_synopsis_more i {
  font-size: 20px;
}

.home_synopsis_more span {
  margin-left: 8px;
}

.home_synopsis_img {
  display: block;
}

.home_ethic_in {
  width: 98%;
  height: 168px;
  display: flex;
  cursor: pointer;
}

.home_ethic_img {
  width: 50%;
  height: 168px;
  position: relative;
}

.home_ethic_info {
  width: 50%;
  height: 168px;
  padding-left: 35px;
  padding-top: 30px;
  box-shadow: 0px 2px 5px 0px rgba(126, 126, 126, 0.24);
  position: relative;
}

.home_ethic_time {
  font-size: 18px;
  color: #1468b9;
  margin-bottom: 15px;
}

.home_ethic_horn {
  font-size: 30px;
  color: #fff;
  position: absolute;
  top: 22px;
  left: -19px;
}

.home_ethic_info:hover {
  background-color: #1468b9;
}

.home_ethic_info:hover .home_ethic_time,
.home_ethic_info:hover .home_ethic_info_text {
  color: #fff;
}

.home_ethic_info:hover .home_ethic_horn,
.home_ethic_info:hover .home_ethic_horn:before {
  color: #1468b9;
}

.home_technology {
  display: flex;
  justify-content: space-between;
}

.home_technology_img {
  width: 443px;
  height: 263px;
}

.home_technology_info {
  width: 680px;
  height: auto;
  position: relative;
  cursor: pointer;
}

.home_technology_info .home_title2 {
  position: absolute;
  left: 0;
  top: 0;
}

.home_technology_in {
  width: 100%;
  height: 56px;
  border-bottom: 1px solid #d6d6d6;
  padding-top: 5px;
  justify-content: space-between;
  font-size: 15px;
  line-height: 50px;
}

.home_technology_left {
  max-width: 500px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.home_technology_right {
  align-items: center;
}

.home_technology_right i {
  font-size: 16px;
}

.home_technology_right span {
  margin-left: 5px;
}

.home_technology_in:hover .home_notice_list_left,
.home_technology_in:hover .home_notice_list_right {
  color: #1468b9;
}

.home_GCP {
  width: 1300px;
  height: 225px;
  margin-left: -50px;
  padding: 0 50px;
  position: relative;
}

.home_GCP_content {
  width: 1220px;
  height: 245px;
  overflow: hidden;
  margin-left: -10px;
}

.home_GCP_content_in {
  width: 1200px;
  height: 225px;
  margin: 10px;
  position: relative;
}

.home_GCP_main {
  position: absolute;
  left: 0;
  top: 0;
  transition: transform 0.5s ease-in-out;
}

.home_GCP_in {
  width: 180px;
  height: 205px;
  display: block;
  box-shadow: 0px 0px 12px 1px rgba(182, 195, 193, 0.2);
  border-radius: 4px;
  background-color: #fff;
  padding-top: 20px;
  margin-right: 24px;
}

.home_GCP_icon {
  width: 65px;
  height: 65px;
  margin: 0 auto;
  background-color: #1468b9;
  border-radius: 100px;
  justify-content: center;
  align-items: center;
  border: 3px solid #d5e4f2;
}

.home_GCP_border {
  width: 40px;
  height: 2px;
  background-color: #1468b9;
  margin: 28px auto;
}

.home_GCP_department {
  width: 100%;
  text-align: center;
  font-size: 16px;
  color: #4d4d4d;
  font-weight: bold;
  margin-bottom: 10px;
}

.home_GCP_name {
  width: 100%;
  text-align: center;
  font-size: 14px;
  color: #808080;
}

.home_GCP_in:hover {
  background-color: #1468b9;
}

.home_GCP_in:hover .home_GCP_border {
  background-color: #fff;
}

.home_GCP_in:hover .home_GCP_department,
.home_GCP_in:hover .home_GCP_name {
  color: #fff;
}
.carousel_btn {
  width: 18px;
  height: 18px;
  cursor: pointer;
  border-radius: 100px;
  position: absolute;
  top: 50%;
  margin-top: -9px;
}

.carousel_btn_left {
  background: url(../../static/images/common/btnLeft1.png) no-repeat;
  background-size: cover;
  left: 20px;
}

.carousel_btn_left:hover {
  background: url(../../static/images/common/btnLeft2.png) no-repeat;
  background-size: cover;
}

.carousel_btn_right {
  background: url(../../static/images/common/btnRight1.png) no-repeat;
  background-size: cover;
  right: 20px;
}

.carousel_btn_right:hover {
  background: url(../../static/images/common/btnRight2.png) no-repeat;
  background-size: cover;
}

.home_link_info {
  justify-content: space-between;
}

.home_link_related_left {
  width: 133px;
  min-height: 60px;
  position: relative;
}

.home_link_related_border {
  width: 0;
  height: 0;
  border-right: 21px solid transparent;
  border-left: 112px solid #81b9ff;
  position: absolute;
  top: 0;
  left: 0;
}

.home_link_left_text {
  height: 40px;
  padding-left: 26px;
  position: absolute;
  top: 50%;
  margin-top: -20px;
  left: 0;
  text-align: left;
}

.home_link_left_text p {
  font-size: 12px;
  color: #fff;
}

.home_link_left_text .home_link_title {
  font-size: 16px;
  margin-bottom: 5px;
}

.home_link_related_right {
  width: 1144px;
  flex-wrap: wrap;
  padding: 10px 0;
}

.home_link_related_in {
  align-items: center;
  height: 40px;
  margin-right: 60px;
  cursor: pointer;
}

.home_link_related_in:nth-child(4n) {
  margin-right: 0;
}

.home_link_related_icon {
  width: 28px;
  height: 28px;
  margin-right: 13px;
}

.home_link_related_name {
  line-height: 40px;
  font-size: 15px;
}

.home_link_links_left {
  width: 163px;
  min-height: 60px;
  position: relative;
}

.home_link_links_border {
  width: 0;
  height: 0;
  border-right: 28px solid transparent;
  border-left: 135px solid #5a99e6;
  position: absolute;
  top: 0;
  left: 0;
}

.home_link_links_right {
  width: 1120px;
  height: 60px;
  flex-wrap: wrap;
  align-items: center;
  padding: 10px 50px;
  position: relative;
}

.links_carousel {
  width: 1020px;
  height: 40px;
  position: relative;
  overflow: hidden;
}

.links_carousel_main {
  position: absolute;
  left: 0;
  top: 0;
  transition: transform 0.5s ease-in-out;
}

.home_link_links_in {
  width: 25%;
  height: 40px;
  align-items: center;
  cursor: pointer;
}

.home_link_links_icon {
  color: #d40a2a;
  margin-right: 10px;
}

.home_link_links_name {
  line-height: 40px;
  font-size: 14px;
}

.home_notice_list_left {
  width: 550px;
  height: 35px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.home_system {
  display: none;
}

.content_list_title {
  margin-bottom: -12px !important;
}

.znnew {
  width: 298px;
  height: 245px;
  background: #ffffff;
  padding-left: 35px;
}

.znnew p {
  font-size: 16px;
  font-family: Microsoft YaHei;
  /* font-weight: bold; */
  width: 68px;
  margin-bottom: 8px;
  margin-top: 5px;
  margin-left: -5px;
  text-align: center;
}

.znnew ul li {
  list-style-type: none;
  font-size: 15px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  /* line-height: 34px; */
  line-height: 40px;
  cursor: pointer;
  display: flex;
}
.znnew ul li img {
  width: 20px;
  margin-right: 10px;
  margin-top: -4px;
  vertical-align: middle;
}

.znnew ul li:hover {
  color: #2975d3;
}
.znnew ul li:hover .jt2 {
  display: inline-block;
}

.znnew ul li:hover .jt1 {
  display: none;
}
.home_notice_list_ul {
  display: flex;
  /* list-style-type: none; */
  flex-wrap: wrap;
}
.home_notice_list_ul li:hover .jt2 {
  display: block;
}
.home_notice_list_ul li:hover .jt1 {
  display: none;
}
.home_notice_list_ul li {
  width: 50%;
  font-size: 15px;
  color: #4d4d4d;
  text-align: justify;
  line-height: 38px;
  cursor: pointer;
  display: flex;
}
.dice_bank img {
  width: 30px;
}
.home_notice_list_ul li div:first-child {
  width: 30px;
  height: 30px;
  /* border-radius: 12px;
  background: #e5e5ee; */
  margin-right: 10px;
  margin-top: 5px;
}

.bannerl {
  position: relative;
}
.bannertitle {
  position: absolute;
  bottom: 0px;
  left: 0px;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  width: 100%;
  height: 50px;
  line-height: 40px;
  padding-left: 30px;
  font-size: 15px;
}

.home_notice_list_ul li:hover {
  color: #2975d3 !important;
}
.more:hover {
  color: #2975d3 !important;
}
.jt2 {
  display: none;
}
.patentRecommendationItems {
  margin-left: 120px;
  list-style-type: none;
}
.patentRecommendationItems li {
  padding: 0px 10px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  font-size: 16px;
  margin-right: 5px;
}

.patentRecommendationItemshover {
  background: rgba(82, 142, 228, 0.1);
  font-weight: bold;
  border-radius: 7px;
  color: #2975d3;
}
@media screen and (max-width: 576px) {
  .more:hover {
    color: #2975d3 !important;
  }
  .home_notice_list_right {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .patentRecommendationItems li {
    font-size: 10px;
  }
  .znnew {
    width: 65% !important;
  }
  .content_list_title {
    width: 70%;
    font-size: 16px;
  }
  .home_link_left_text {
    height: 30px;
    padding-left: 26px;
    position: absolute;
    top: 24px;
    left: 0;
    text-align: left;
  }
  .home_notice_list div:first-child {
    width: 60%;
  }
  .home_link_related_right {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .links_carousel {
    width: 90%;
  }
  .home_notice_in {
    width: 50%;
    padding: 10px 10px;
  }
  .dice_banks {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .home_notice_img {
    width: 100%;
    height: 100px;
  }

  .home_content {
    padding: 0px 10px;
  }

  .home_synopsis_info {
    width: 100%;
  }

  .home_tltie1_name span {
    display: none;
  }

  .home_tltie1_name {
    font-size: 16px;
  }

  .home_content_in2 {
    margin-left: 0px;
  }
  .home_technology {
    display: flex;
  }
  .home_technology_img {
    margin-right: 40px;
  }
  .home_technology_info {
    width: 100%;
  }

  .home_notice_list_left {
    width: 250px;
  }

  .home_GCP_content {
    width: 100%;
  }

  .home_GCP_content_in {
    width: 100%;
  }

  .home_GCP_in {
    padding-top: 5px;
  }

  .home_GCP {
    width: 100%;
    margin-left: 0px;
  }

  .home_system {
    display: block;
  }
}
</style>


// WEBPACK FOOTER //
// src/view/home.vue